import React from 'react';
import { IoMdMail } from "react-icons/io";
import { FaPhoneAlt } from "react-icons/fa";
import { BiSolidMap } from "react-icons/bi"; 
import './Header.css';

const Header = () => {
  return (
    <div className="top-bar">
      <div className="container d-flex justify-content-between flex-wrap">
        <div className="left-info d-flex gap-4">
          <div className="info-item d-flex align-items-center">
            <FaPhoneAlt className="icon" />
            <a href="tel:+910000000000" style={{ color: 'white', textDecoration: 'none' }}>
  +91 0000000000
</a>
          </div>
          <div className="info-item d-flex align-items-center">
            <IoMdMail className="icon" />
            <span>info@loanonsalary.com</span>
          </div>
        </div>

        <div className="right-info info-item d-flex align-items-center">
  <BiSolidMap className="icon" />
  <span>1710, 17TH Floor, World Trade Tower, Sector 16, Noida, Uttar Pradesh.</span>
</div>


      </div>
    </div>
  );
};

export default Header;
